import React from "react";

const RemixQuizIcon = (props) => (
  <svg
    width="64"
    height="35"
    viewBox="0 0 64 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="35" rx="17.5" fill="#5DCDFD" />
    <g clipPath="url(#clip0_quiz)">
      <path
        d="M31.004 23.5C31.4018 23.5 31.7834 23.658 32.0647 23.9393C32.346 24.2206 32.504 24.6022 32.504 25C32.504 25.3978 32.346 25.7794 32.0647 26.0607C31.7834 26.342 31.4018 26.5 31.004 26.5H31C30.6022 26.5 30.2206 26.342 29.9393 26.0607C29.658 25.7794 29.5 25.3978 29.5 25C29.5 24.6022 29.658 24.2206 29.9393 23.9393C30.2206 23.658 30.6022 23.5 31 23.5H31.004ZM31 7.5C32.7239 7.5 34.3772 8.18482 35.5962 9.40381C36.8152 10.6228 37.5 12.2761 37.5 14C37.5 15.896 36.326 17.605 34.62 18.578C33.983 18.942 33.42 19.36 33.031 19.808C32.651 20.245 32.5 20.636 32.5 21C32.5 21.3978 32.342 21.7794 32.0607 22.0607C31.7794 22.342 31.3978 22.5 31 22.5C30.6022 22.5 30.2206 22.342 29.9393 22.0607C29.658 21.7794 29.5 21.3978 29.5 21C29.5 19.707 30.067 18.646 30.766 17.84C31.456 17.045 32.332 16.43 33.134 15.973C34.093 15.425 34.5 14.618 34.5 14C34.5 13.5404 34.4095 13.0852 34.2336 12.6606C34.0577 12.236 33.7999 11.8501 33.4749 11.5251C33.1499 11.2001 32.764 10.9423 32.3394 10.7664C31.9148 10.5905 31.4596 10.5 31 10.5C30.5404 10.5 30.0852 10.5905 29.6606 10.7664C29.236 10.9423 28.8501 11.2001 28.5251 11.5251C28.2001 11.8501 27.9423 12.236 27.7664 12.6606C27.5905 13.0852 27.5 13.5404 27.5 14C27.5 14.197 27.4612 14.392 27.3858 14.574C27.3104 14.756 27.1999 14.9214 27.0607 15.0607C26.9214 15.1999 26.756 15.3104 26.574 15.3858C26.392 15.4612 26.197 15.5 26 15.5C25.803 15.5 25.608 15.4612 25.426 15.3858C25.244 15.3104 25.0786 15.1999 24.9393 15.0607C24.8001 14.9214 24.6896 14.756 24.6142 14.574C24.5388 14.392 24.5 14.197 24.5 14C24.5 12.2761 25.1848 10.6228 26.4038 9.40381C27.6228 8.18482 29.2761 7.5 31 7.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_quiz">
        <rect width="24" height="24" fill="white" transform="translate(19 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default RemixQuizIcon;
